import { Button, Space, Typography } from "antd";
import Img from "assets/images";
import CustomModal from "components/CustomModal";

import { useState } from "react";
import { useHistory } from "react-router-dom";

function ModalSelectCampaign({ visible, handleGetValueVisibleModal }) {
  const history = useHistory();
  const [valueCampaign, setValueCampaign] = useState();

  // check i18n
  const buttonData = [
    {
      key: "TOP_SALES",
      icon: Img.ImageTopSales,
      onClick: () => setValueCampaign("TOP_SALES"),
      text: "Đua top",
    },
    {
      key: "COMBO_PROMO",
      icon: Img.ImageComboPromo,
      onClick: () => setValueCampaign("COMBO_PROMO"),
      text: "Khuyến mãi theo combo",
      description: [
        "Mua sản phẩm A kèm sản phẩm B, giảm tiền trên combo",
        "Mua sản phẩm A kèm sản phẩm B, tặng quà",
        "Mua gói X sản phẩm chỉ với giá",
      ],
    },
    {
      key: "PRODUCT_PROMO",
      icon: Img.ImageProductPromo,
      onClick: () => setValueCampaign("PRODUCT_PROMO"),
      text: "Khuyến mãi trên 1 sản phẩm",
      description: ["Mua sản phẩm A được giảm tiền"],
    },
    {
      key: "ORDER_PROMO",
      icon: Img.ImageOrderPromo,
      onClick: () => setValueCampaign("ORDER_PROMO"),
      text: "Khuyến mãi cho đơn hàng",
      description: ["Đơn hàng đạt giá trị tối thiểu được giảm tiền "],
    },
    {
      key: "LOYALTY_CASH",
      icon: Img.ImageCashDiscount,
      onClick: () => setValueCampaign("LOYALTY_CASH"),
      text: "Chiết khấu tiền mặt",
      description: ["Giảm giá với sản phẩm thanh toán bằng Chuyển khoản/ Tiền mặt"],
    },
  ];

  const handleClose = () => {
    handleGetValueVisibleModal(!visible);
    setValueCampaign(undefined);
  };

  const handleOke = () => {
    if (valueCampaign) {
      history.push({
        pathname: "/campaign/create",
        search: `?campaignType=${valueCampaign}`,
        state: { campaignType: valueCampaign },
      });
    }
  };

  return (
    <CustomModal
      {...{
        message: <Typography.Title level={4}>Chọn loại chương trình</Typography.Title>,
        footer: false,
        okeButtonLabel: "Áp dụng",
        width: "max-content",
        onCancel: handleClose,
        visible: visible,
        closable: false,
        onOke: handleOke,
        children: (
          <Space direction="vertical" style={{ width: "100%", height: "100%" }}>
            {buttonData.map((button) => (
              <Button
                key={button?.key}
                onClick={button?.onClick}
                style={{
                  width: "100%",
                  height: "100%",
                  padding: "12px 24px",
                }}
              >
                <Space style={{ display: "flex", alignItems: "center" }}>
                  <img src={button?.icon} alt="" width={42} height={42} />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "baseline",
                      padding: "0 12px",
                    }}
                  >
                    <Typography.Text
                      strong
                      style={{ fontSize: "15px", color: button.key === valueCampaign && "#1953D8" }}
                    >
                      {button?.text}
                    </Typography.Text>
                    {button?.description?.map((text) => (
                      <Typography.Text strong style={{ fontSize: "12px", color: "#5B6673" }}>
                        {text}
                      </Typography.Text>
                    ))}
                  </div>
                </Space>
              </Button>
            ))}
          </Space>
        ),
      }}
    />
  );
}

export default ModalSelectCampaign;
